export function getProductSize(size?: string | null): string {
    return size?.trim() || "SANS_TAILLE";
}
